import React from 'react';

import { SectionLabel } from './SectionLabel';
import { LocationNodeData } from '../../../../@types';
import { LiveSearchBox, LiveSearchListItem } from '../../../../components/atoms/LiveSearchBox';
import { LocationSearchItem } from '../../../../components/molecules/LocationSearchItem';
import { useSearchAllocationNodes } from '../../../../queries/live-search-query';

export interface AllocationFieldProps {
  value: string;
  onChange: (name: string, nodeId?: number) => void;
  suggestions?: LocationNodeData[];
  disabled?: boolean;
  lockReason?: string;
  locked?: boolean;
}

export const AllocationField: React.FC<AllocationFieldProps> = ({
  value,
  onChange,
  suggestions,
  disabled,
  lockReason,
  locked,
}) => {
  const searchAllocationNodes = useSearchAllocationNodes();
  return (
    <SectionLabel label="User / Depot Allocation" lockReason={lockReason} locked={locked}>
      <LiveSearchBox
        title="User / Depot Allocation"
        hideInlineLabel
        timeOffset={400}
        value={value}
        disabled={disabled || !!lockReason || !!locked}
        defaultSuggetions={suggestions}
        onClearValue={() => onChange('', undefined)}
        renderItem={(props, option) => (
          <LiveSearchListItem {...props}>
            <LocationSearchItem data={option} />
          </LiveSearchListItem>
        )}
        onChange={(obj: LocationNodeData) => onChange(obj?.name ?? '', obj?.id)}
        onApiInvoke={async (name) => await searchAllocationNodes.mutateAsync(name)}
      />
    </SectionLabel>
  );
};
